import React, { useContext, useEffect, useState } from "react";
import Header from "../Coman/Header";
import LoginBox from "./LoginBox";
import Faq from "../Dashboard/Faq";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";

function Error() {
  const { account, dbuser, toastError, toastSuccess, fetchUserData, settings } = useContext(ProjectContext); // Assuming fetchUserData fetches the user info
  const [loading, setLoading] = useState(true); // state for loading (initially true)
  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();

  useEffect(() => {
    // If dbuser address is valid, navigate to dashboard
    if (dbuser?.address !== '0x0000000000000000000000000000000000000000' && dbuser !== null) {
      navigate("/dashboard");
    }
  }, [dbuser, navigate]);

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchUserData(); // Replace this with your actual data fetching logic (if it’s asynchronous)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading after the data fetch is done
      }
    };

    if (!dbuser) {
      loadData(); // Fetch data only if dbuser is not already present
    } else {
      setLoading(false); // If dbuser is already available, stop loading
    }
  }, [dbuser, fetchUserData]);

  const addCustomToken = async () => {
    try {
      // Check if MetaMask is available
      if (typeof window.ethereum !== 'undefined') {

        // Ensure the token address is a valid Ethereum address (BEP20 tokens are also ERC20 tokens on Binance Smart Chain)
        if (!ethers.utils.isAddress(settings?.defin)) {
          toastError('Invalid token address');
          return;
        }


        // Try adding the ERC20/BEP20 token to the wallet
        const tokenAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20',  // BEP20 tokens are considered ERC20 tokens on BSC
            options: {
              address: settings?.defin,  // Token contract address
              symbol: "DEFIN",    // Token symbol (e.g., 'USDT')
              decimals: 18, // Token decimals (e.g., 18)
            },
          },
        });

        console.log("tokenAdded", tokenAdded);

        // Notify the user whether the token was successfully added
        if (tokenAdded) {
          toastSuccess('Token added successfully!');
        } else {
          toastSuccess('Token addition failed. Please check the details.');
        }
      } else {
        // If MetaMask is not installed, alert the user
        toastError('MetaMask is not installed. Please install MetaMask to add custom tokens.');
      }
    } catch (error) {
      // Handle any errors during the process
      toastError('An error occurred while adding the token.');
      console.error('Error adding custom token:', error);
    }
  };


  const addCustomNetwork = async () => {
    try {
      // Check if MetaMask is available
      if (typeof window.ethereum !== 'undefined') {
        // The network configuration you want to add (Example: Binance Smart Chain)
        const customNetwork = {
          chainId: '0x38', // 0x38 is the chain ID for BSC Mainnet
          chainName: 'Binance Smart Chain',
          rpcUrls: ['https://bsc-dataseed1.binance.org:443'], // RPC URL for BSC
          nativeCurrency: {
            name: 'Binance Coin',
            symbol: 'BNB', // Symbol for the native currency
            decimals: 18,
          },
          blockExplorerUrls: ['https://bscscan.com'], // URL for BSC Block Explorer
        };

        // Add the custom network to MetaMask
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [customNetwork],
        });

        toastSuccess('Custom network added successfully!');
      } else {
        toastError('MetaMask is not installed. Please install MetaMask first.');
      }
    } catch (error) {
      console.error('Error adding custom network:', error);
      toastError('Failed to add custom network. Please check the console for errors.');
    }
  };
  return (
    <div>
      <div id="main-wrapper" className="show">
        <div>
          <div className="content-body pt-0">
            <div className="d-flex align-items-center  justify-content-center text-start">
              <div className="">
                {/* Background Video */}
                <video
                  autoPlay
                  muted
                  loop
                  className="video-1 w-100 h-100"
                  playsInline
                // className="w-100 d-none d-sm-block"
                >
                  <source src="assets/img/hero.mp4" type="video/mp4" />
                </video>


                {/* Centered Content */}
                <div className="d-flex justify-content-center mt-5">
                  {/* <div className="position-absolute box-new-op start-50 translate-middle w-100 d-flex justify-content-center"> */}
                  <div>
                    <div className="d-flex justify-content-center mb-4">
                      <div className="text-white text-center rounded shadow-lg box-login-size">
                        <img src="../assets/img/logo.svg" width="250" alt="" srcset="" />
                        <br />
                        {/* Show loading spinner */}
                        {loading ? (
                          <div className="loader"> {/* Your loader component */} </div>
                        ) : (
                          <>
                            {!account ? (
                              <button
                                type="button"
                                onClick={() => openConnectModal()}
                                className="text-white p-3 px-4 btn-outline-bg-new-primary"
                              >
                                Log in
                              </button>
                            ) : (
                              <>
                                {dbuser?.address !== '0x0000000000000000000000000000000000000000' && dbuser !== null ? (
                                  // Show content after address is valid
                                  <div>Address is valid</div>
                                ) : (
                                  <>
                                    <h2 className="fw-medium my-3 text-white">No Referral ID</h2>
                                    <p className="fw-medium my-3">
                                      You must use a valid referral link to access this page.
                                    </p>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                        <div className="d-flex justify-content-between mt-5">
                          <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2" onClick={addCustomToken}>
                            <b className="fs-18">Add Token</b>
                          </span>
                          <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2" onClick={addCustomNetwork}>
                            <b className="fs-18">Add Chain</b>
                          </span>
                        </div>
                      </div>
                    </div>
                    <Faq />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error;
